const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:5000';

async function authFetch(path: string, token: string, options?: RequestInit) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options?.headers || {})
    }
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || 'Request failed');
  }

  return response.json();
}

async function parse(response: Response) {
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || 'Request failed');
  }
  return response.json();
}

export async function adminLogin(credentials: { email: string; password: string }) {
  const response = await fetch(`${API_BASE_URL}/api/admin/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials)
  });
  return parse(response);
}

export function fetchAdminOverview(token: string) {
  return authFetch('/api/admin/overview', token);
}

export function fetchContactMessages(token: string) {
  return authFetch('/api/admin/contacts', token);
}

export function fetchJobApplications(token: string) {
  return authFetch('/api/admin/jobs', token);
}

export function updateContactStatus(token: string, id: number, status: string) {
  return authFetch(`/api/admin/contacts/${id}/status`, token, {
    method: 'PATCH',
    body: JSON.stringify({ status })
  });
}

export function updateJobStatus(token: string, id: number, status: string) {
  return authFetch(`/api/admin/jobs/${id}/status`, token, {
    method: 'PATCH',
    body: JSON.stringify({ status })
  });
}

